module.exports = {
  title: '用户审核详情',
  route: {
    path: '/user-manage',
    children: {
      path: 'user-audit-details',
    },
  },
};
